import React, { useState, useEffect, useRef } from "react";
import { Caption } from "./cms-data";
import { Utils } from "./utils";
//import "./transcript-component.css";
//import "./panel-component.css";
import { Timecode } from "./timecode";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";
import { filterIcon, printIcon } from "./constants";
import TranscriptComponentState from './transcript-component-state';
import { TextField } from '@att-bit/duc.components.text-field';
export type TranscriptComponentProps = {
  /**
   *  Data to load Transcript
   */
  data: TranscriptComponentData;
  /**
   *  Events for the Transcript
   */
  events?: TranscriptComponentEvents;
  /**
   *  Additional options for Transcript to enable different interfaces like Model etc.
   */
  options?: TranscriptComponentOptions;
  /**
   *  Additional id passed to Transcript
   */
  testId?: string;
};

export type TranscriptComponentData = {
  captionData?: any;
  currentTime?: number;
  printTitle?: string;
  duration?: string;
  date?: string;
  thumbIcon?: string;
  chapteredVideoData?: string[];
};

export type TranscriptComponentOptions = {
  className: string;
  containerWidth?: any;
};

export type TranscriptComponentEvents = {
  updateCurrentTime(time: number): void;
};
export class TranscriptComponent extends React.Component<TranscriptComponentProps, TranscriptComponentState> {
  state: TranscriptComponentState;
  filterRef: any;
  activeRef: any;
  transcriptBodyRef: any;
  activeCaption!: Caption;
  captions: any = [];
  filterCaption = true;
  private chapteredVideoDataArray: any = [];

  constructor(props: TranscriptComponentProps) {
    super(props);
    this.filterRef = React.createRef();
    this.activeRef = React.createRef();
    this.transcriptBodyRef = React.createRef();
    // this.activeCaption = null;
    this.state = new TranscriptComponentState();
    this.loadTranscript = this.loadTranscript.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleTextClick = this.handleTextClick.bind(this);
    this.print = this.print.bind(this);
    this.printTranscript = this.printTranscript.bind(this);
  }
  componentDidMount(){
    let transcriptContainerClassName = '';
      if(this.props.options && this.props.options.containerWidth &&  this.props.options.containerWidth  >= 0 && this.props.options.containerWidth  <= 214){
        transcriptContainerClassName = 'panelComponent__panel__GT0__LT214';
      }
      if(this.props.options && this.props.options.containerWidth &&  this.props.options.containerWidth  > 214 && this.props.options.containerWidth  <= 500){
        transcriptContainerClassName = 'panelComponent__panel__GT214__LT500';
      }
      if(this.props.options && this.props.options.containerWidth &&  this.props.options.containerWidth  > 500 && this.props.options.containerWidth  <= 800){
        transcriptContainerClassName = 'panelComponent__panel__GT500__LT800';
      }
      if(this.props.options && this.props.options.containerWidth &&  this.props.options.containerWidth  > 800){
        transcriptContainerClassName = 'panelComponent__panel__GT800';
      }
      this.setState({transcriptContainerClassName: transcriptContainerClassName});

  }
  shouldComponentUpdate(nextProps: TranscriptComponentProps, nextState: TranscriptComponentState) {
    this.filterCaption = nextState.filterText === this.state.filterText ? false : true;
    const currTime = nextProps.data.currentTime;
    const updateActivCaption = this.activeCaption &&
      this.activeCaption.begin < currTime! && this.activeCaption.end > currTime!;
    return this.filterCaption || !updateActivCaption;
  }

  componentDidUpdate() {
    if (this.activeRef && this.activeRef.current && this.transcriptBodyRef && this.transcriptBodyRef.current) {
      // this.activeRef.current.scrollIntoView();
      const body = this.transcriptBodyRef.current;
      body.scrollTop = this.activeRef.current.offsetTop - body.getBoundingClientRect().height / 2;
    }
  }

  render() {
    const customClassName = this.props.options && this.props.options.className ? this.props.options.className : '';
    const utilityClass = this.props.data.chapteredVideoData && this.props.data.chapteredVideoData.length > 0 ?
      "TranscriptComponent__hideUtility" : "panelComponent__utilities";
    const transcriptStyles = /*
    // @ts-ignore */
    <style jsx global>{`
    .TranscriptComponent__panel {
      display: flex;
      flex-direction: column;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      white-space: normal;
      min-height: 0;
      max-height: 100%;
      background: #ffffff;
      border-radius: 7px;
      padding: 10px;
      box-sizing: border-box;
    }
    
    .TranscriptComponent__button,
    .TranscriptComponent__buttonPrint {
      flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      width: 46px;
      height: 46px;
      padding: 4px;
      font-size: 35px;
      color: #999999;
      background: transparent;
      border: 0;
    }
    
    .TranscriptComponent__buttonPrint {
      margin-left: 4px;
    }
    
    .TranscriptComponent__button:hover,
    .TranscriptComponent__buttonPrint:hover {
      color: #666666;
    }
    
    .TranscriptComponent__utilities {
      flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      margin-top: 10px;
      font-size: 1em;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @media screen and (min-width: 0px) and (max-width: 214px) {
      .TranscriptComponent__panel
        .TranscriptComponent__utilities {
        flex-wrap: wrap;
      }
    }

      .panelComponent__panel__GT0__LT214
        .TranscriptComponent__utilities {
        flex-wrap: wrap;
      }
    
    .TranscriptComponent__field {
      flex: 1 1 auto;
      -ms-flex: 1 1 auto;
      font-size: 1em;
      height: 2.4em !important;
      position: relative;
    }
    
    .TranscriptComponent__icon {
      position: absolute;
      height: 25px;
      width: 28px;
      color: #999999;
      top: 50%;
      left: 4px;
      transform: translate(0, -50%);
      z-index: 1;
    }
    .TranscriptComponent__icon svg {
      padding: 5px 4px;
    }
    
    .TranscriptComponent__printTranscript {
      background: transparent;
      border: none;
      padding: 0px 5px 0 10px;
      height: 30px;
    }
    
    .TranscriptComponent__input {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      min-width: 0px;
      background-color: #ffffff;
      border-radius: 6px;
      border: 1px solid #d2d2d2;
      box-shadow: -1px 3px 2px -2px rgba(0, 0, 0, 0.08) inset;
      transition: border 0.3s linear 0s;
      margin: 0px !important;
      padding-left: 34px !important;
      font-size: 100%;
    }
    
    .TranscriptComponent__input:focus {
      border: 1px solid #d2d2d2;
      outline: 0px;
    }
    
    .TranscriptComponent__input::-ms-clear {
      display: none;
    }
    
    /*
    transcripts
    */
    .TranscriptComponent__body {
      /*border:1px solid #f5f5f5;*/
      background-color: #f2f2f2;
      border-radius: 7px;
      line-height: 1.5em;
      /*margin-top: 10px;*/
      overflow-y: scroll;
      overflow-x: hidden;
      flex: 1 1 auto;
      position: relative;
      text-align: left;
    }
    
    .TranscriptComponent__transcripts {
      margin: 10px;
      padding: 6px;
      display: block;
      cursor: pointer;
      border-radius: 7px;
      border-style: none;
      text-align: left;
      font-size: 100%;
    }
    
    @media screen and (min-width: 0px) and (max-width: 220px) {
      .TranscriptComponent__panel
        .TranscriptComponent__transcripts {
        margin: 0px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

    @media screen and (min-width: 0px) and (max-width: 220px) {
      .panelComponent__panel
        .TranscriptComponent__transcripts {
        margin: 0px;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }

      .panelComponent__panel__GT0__LT214
        .TranscriptComponent__transcripts {
        margin: 0px;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .panelComponent__panel__GT0__LT214
        .TranscriptComponent__transcripts_styles {
        font-size: 1rem;
      }
    
      .panelComponent__panel__GT214__LT500 
        .TranscriptComponent__transcripts_styles {
        font-size: 0.5rem;
      }

      .panelComponent__panel__GT500__LT800 
        .TranscriptComponent__transcripts_styles {
        font-size: 1.1rem;
      }

      .panelComponent__panel__GT800
        .TranscriptComponent__transcripts_styles {
        font-size: 1.1rem;
      }
      
      .panelComponent__panel__GT800
        .TranscriptComponent__transcripts_styles {
        font-size: 100%;
      }

    
    .TranscriptComponent__transcripts strong {
      font-family: Omnes-ATT-W02, Omnes_att_ii_regular, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
      font-weight: 900;
      border-radius: 3px;
    }
    
    .TranscriptComponent__transcriptsActive {   
    }
    
    .TranscriptComponent__focused:focus {
      outline: none;
      box-shadow: inset 0px 0px 0px 3px #009fdb;
    }
    
    /*
    for printing
    */
    .TranscriptComponent__printLine1 {
      width: 100%;
      height: 1px;
      float: left;
      margin-top: 20px;
    }
    
    .TranscriptComponent__printLine2 {
      width: 100%;
      height: 1px;
      float: left;
      margin-top: 10px;
    }
    
    .TranscriptComponent__printdescription {
      margin-top: 10px;
      font-family: arial;
      float: left;
    }
    
    .TranscriptComponent__printdescription1 {
      position: relative;
      float: left;
      width: 140px;
      height: 76px;
    }
    
    .TranscriptComponent__printbackgrimg {
      position: absolute;
      left: 0px;
      top: 0px;
    }
    
    .TranscriptComponent__printthumbIcon {
      position: absolute;
      left: 15px;
      top: 7px;
    }
    
    .TranscriptComponent__printvidouterdiv {
      float: left;
      margin-left: 20px;
    }
    
    .TranscriptComponent__printviddis {
      font-size: 14pt;
    }
    
    .TranscriptComponent__printvidtitle {
      font-size: 20pt;
    }
    
    .TranscriptComponent__printvidtimecode {
      font-size: 12pt;
      color: #666666;
    }
    
    .TranscriptComponent__printbody {
      margin-top: 10px;
      font-size: 12pt;
      font-family: arial;
      clear: left;
      float: left;
    }
    
    .TranscriptComponent__printbodyspan {
      display: inline;
      color: #666666;
    }
    
    .TranscriptComponent__printbodymargintop {
      margin-top: 10px;
    }
    
    .TranscriptComponent__printbodymarginbottom {
      margin-bottom: 10px;
    }
    
    .TranscriptComponent__buttonPrint {
      /*padding: 6px;*/
      margin-left: 4px;
    }
    
    .TranscriptComponent__fill,
    .TranscriptComponent__column,
    .TranscriptComponent__row {
      width: 100%;
      height: 100%;
      flex: 1;
      position: relative;
      margin: auto;
      display: block;
      box-sizing: border-box;
      -webkit-font-smoothing: auto;
      -moz-osx-font-smoothing: auto;
      outline: none;
    }
    
    .TranscriptComponent__column {
      display: flex;
      flex-direction: column;
    }
    
    .TranscriptComponent__row {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    
    .TranscriptComponent__center {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
    
    .TranscriptComponent__hideUtility {
      visibility: hidden;
      height: 0px;
    }
    
    .TranscriptComponent__spacing {
      padding-top: 12px;
      padding-bottom: 12px;
    }
    `}</style>;
    const panelStyles = /*
    // @ts-ignore */
    <style jsx global>{`
    .panelComponent__panel {
      display: flex;
      flex-direction: column;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      white-space: normal;
      min-height: 0;
      max-height: 100%;
      background: #ffffff;
      border-radius: 7px;
      padding: 10px;
      box-sizing: border-box;
      text-align: left;
      margin-left: 10px;
      margin-top: 3em;
    }
    
    .panelComponent__button {
      flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      width: 46px;
      height: 46px;
      padding: 4px;
    }
    
    .panelComponent__button:hover path {
      fill: #666666;
    }
    
    .panelComponent__utilities {
      flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      margin-top: 10px;
      font-size: 1em;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    @media screen and (min-width: 0px) and (max-width: 214px) {
      .panelComponent__panel
        .panelComponent__utilities {
        flex-wrap: wrap;
      }
    }

    .panelComponent__panel__GT0__LT214
        .panelComponent__utilities {
        flex-wrap: wrap;
    }

    .form-row, .form-row+.inline-form-row {
      margin-top: 0px !important;
    }
    .form-row .textfield, .form-row+.inline-form-row .textfield{
      padding-left: 34px !important;
    }
    .panelComponent__field {
      flex: 1 1 auto;
      -ms-flex: 1 1 auto;
      font-size: 1em;
      height: 2.4em !important;
      position: relative;
    }
    
    .panelComponent__icon {
      position: absolute;
      height: 28px;
      width: 28px;
      fill: #999999;
      top: 50%;
      left: 4px;
      transform: translate(0, -50%);
      z-index: 1;
    }
    
    .panelComponent__input {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      min-width: 0px;
      border-radius: 6px;
      border: 1px solid #d2d2d2;
      box-shadow: -1px 3px 2px -2px rgba(0, 0, 0, 0.08) inset;
      transition: border 0.3s linear 0s;
      margin: 0px !important;
      padding-left: 34px !important;
      font-size: 1em;
    }
    
    .panelComponent__input:focus {
      border: 1px solid #d2d2d2;
      outline: 0px;
    }
    
    .panelComponent__body {
      /*border:1px solid #f5f5f5;*/
      border-radius: 7px;
      line-height: 1.5em;
      /*margin-top: 10px;*/
      overflow-y: scroll;
      overflow-x: hidden;
      flex: 1 1 auto;
      position: relative;
      text-align: left;
    }
    
    /*
    extra styles of content placeholder
    */
    .panelComponent__input::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      font-family: Omnes-ATT-W02, Omnes_att_ii_regular, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    }
    
    .panelComponent__input::-moz-placeholder {
      /* Firefox 19+ */
      font-family: Omnes-ATT-W02, Omnes_att_ii_regular, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    }
    
    .panelComponent__input:-ms-input-placeholder {
      /* IE 10+ */
      font-family: Omnes-ATT-W02, Omnes_att_ii_regular, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    }
    
    .panelComponent__input:-moz-placeholder {
      /* Firefox 18- */
      font-family: Omnes-ATT-W02, Omnes_att_ii_regular, "Helvetica Neue", Helvetica,
        Arial, sans-serif;
    }
    `}</style>;
    return (
      <>
            <div role="group" className={"panelComponent__panel" + ' ' + this.state.transcriptContainerClassName + ' ' + customClassName}>
        <div className={"TranscriptComponent__column"}>
          <div className={"panelComponent__body bg-gray-200"} tabIndex={-1} ref={this.transcriptBodyRef}>
            <div style={{ position: 'absolute', width: '100%', height: '100%', boxSizing: 'border-box' }} >
              {this.loadTranscript()}
            </div>
          </div>
          <div className={utilityClass} >
            <div className={"panelComponent__field font-regular"}>
              <div className={"panelComponent__icon color-gray-600"}>
                <IconSvg size={IconSvgSizes.XS} svgNodeStr={filterIcon} altText={'filter Icon Transcript'}/>
              </div>
              <TextField 
                className={"panelComponent__input bg-white" + ' ' + 'gvp_transcript_filter'}
                // type="text"
                placeHolder="Content filter"
                title="Content Filter"
                report-title="Transcript Search Button"
                aria-label="Video Transcript Content Filter"
                //ref={this.filterRef}
                onChange={this.handleFilterChange}
              />
            </div>
            <button
              className={"TranscriptComponent__printTranscript color-att-blue color-cobalt-600 font-regular"}
              onClick={this.printTranscript}
              title="Print Transcript"
              report-title="Transcript Print Button"
              aria-label="Print Transcript"
            >
              <IconSvg size={IconSvgSizes.MD} svgNodeStr={printIcon} altText={'print Icon Transcript'} />
            </button>
          </div>
        </div>
      </div >
      {transcriptStyles}
      {panelStyles}
      </>
    );
  }

  handleFilterChange(e: React.ChangeEvent<HTMLInputElement>) {
    let filterInputText = e.currentTarget.value;
    filterInputText = filterInputText.toLowerCase().replace(/^\s+|\s+$/g, '');
    if (filterInputText.length > 3 && this.state.filterText !== filterInputText) {
      this.setState({ filterText: filterInputText });
    } else if (this.state.filterText !== '') {
      this.setState({ filterText: '' });
    }
  }

  handleTextClick(e: React.FormEvent<HTMLButtonElement>) {
    if (this.props.data && this.props?.data?.chapteredVideoData!?.length > 0) {
      const chapteredString: any = this.props.data.chapteredVideoData;
      const n = this.chapteredVideoDataArray.length;
      for (let i = 0; i < n; i++) {
        const id = `${i}`;
        if (e.currentTarget.getAttribute('id') === id) {
          if (id === '0') {
            this.props.events.updateCurrentTime(0);
            break;
          } else {
            let time: number = 0;
            let j = i;
            while (j !== 0) {
              time = time + Timecode.timecodeToSeconds(chapteredString[j - 1].raw.length);
              j--;
            }
            this.props.events.updateCurrentTime(time);
          }
        }
      }
    } else {
      const beginTime = +e.currentTarget.getAttribute('data-begin')!;
      this.props.events.updateCurrentTime(beginTime);
    }
  }

  activeButtonStyle = (index: number) => {
    const btnExist = document.getElementById(this.chapteredVideoDataArray[index].props.id);
    const btnStyle = ["TranscriptComponent__transcripts TranscriptComponent__transcripts_styles font-regular color-gray-800", "TranscriptComponent__spacing", "TranscriptComponent__transcriptsActive bg-gray-800  color-white"].join(' ');
    if (btnExist) {
      btnExist.setAttribute('class', btnStyle);
    }
  }

  inActiveButtonStyle = (index: number) => {
    const btnExist = document.getElementById(this.chapteredVideoDataArray[index].props.id);
    const btnStyle = ["TranscriptComponent__transcripts TranscriptComponent__transcripts_styles font-regular color-gray-800", "TranscriptComponent__spacing", "color-gray-800"].join(' ');
    if (btnExist) {
      btnExist.setAttribute('class', btnStyle);
    }
  }

  loadTranscript() {
    if (this.props.data && this.props.data.chapteredVideoData && this.props.data.chapteredVideoData.length > 0) {
      let id = 0;
      const currTime = this.props.data.currentTime;
      const chapteredString: any = this.props.data.chapteredVideoData;
      if (chapteredString && this.chapteredVideoDataArray.length === 0) {
        const btnStyle = ["TranscriptComponent__transcripts TranscriptComponent__transcripts_styles font-regular color-gray-800", "TranscriptComponent__spacing"].join(' ');
        chapteredString.map((list: any) => {
          this.chapteredVideoDataArray.push(
            <button
              id={`${id}`}
              key={`${id}`}
              className={btnStyle}
              title="seek video to the video title"
              onClick={this.handleTextClick}
            >
              {list.raw.windowTitle} {` (${list.raw.length})`}
            </button>,
          );
          id++;
        });
      }
      if (currTime! > 0) {
        let k;
        const n = this.chapteredVideoDataArray.length;
        if (currTime! > 0 && currTime! < Timecode.timecodeToSeconds(chapteredString[0].raw.length)) {
          this.activeButtonStyle(0);
        } else {
          this.inActiveButtonStyle(0);
        }
        for (let j = 1; j < n; j++) {
          let startTime = 0;
          let endTime = 0;
          k = j;
          while (k !== 0) {
            startTime = startTime + Timecode.timecodeToSeconds(chapteredString[k - 1].raw.length);
            k--;
          }
          endTime = startTime + Timecode.timecodeToSeconds(chapteredString[j].raw.length);
          if (currTime! >= startTime && currTime! < endTime) {
            this.activeButtonStyle(j);
          } else {
            this.inActiveButtonStyle(j);
          }
        }
      }
      return this.chapteredVideoDataArray;
    } else {
      const groups: Caption[] = Utils.groupCaptions(this.props?.data?.captionData!?.captions);
      const groupLength: number = groups.length;
      this.captions = [];
      let results: number[] = [];
      let i: number = 0;
      for (i; i < groupLength; i++) {
        const group: Caption = groups[i];
        const currTime = this.props.data.currentTime;
        const active = currTime && currTime >= group.begin && currTime < group.end;
        if (active) {
          this.activeCaption = group;
        }
        if (this.state.filterText !== '') {
          const reg = new RegExp(this.state.filterText, 'gi');
          const str: string = group.text;
          while (reg.exec(str.toLowerCase())) {
            results.push(reg.lastIndex);
          }
          if (!results.length) {
            continue;
          }
        }
        this.captions.push(
          <button
            className={"TranscriptComponent__transcripts font-regular TranscriptComponent__transcripts_styles " + (active ? ' ' + "TranscriptComponent__transcriptsActive bg-gray-800 color-white" : ' color-gray-800')}
            title="Seek Video To Text"
            report-title="Transcript Slider"
            data-begin={group.begin}
            data-end={group.end}
            key={`video-${i}`}
            type="button"
            onClick={this.handleTextClick}
            ref={active ? this.activeRef : null}
          >
            {(() => {
              const text: any = [];
              if (results.length) {
                let lastIndex: number = group.text.length;
                let j: number = results.length - 1;
                for (j; j >= 0; j--) {
                  const nextIdx: number = j > 0 ? results[j - 1] : 0;
                  text.unshift(group.text.slice(Number(results[j]), lastIndex));
                  text.unshift(
                    <strong className="color-white bg-att-blue">
                      {group.text.slice(Number(results[j]) - this.state.filterText.length, Number(results[j]))}
                    </strong>);
                  text.unshift(group.text.slice(nextIdx, Number(results[j]) - this.state.filterText.length));
                  lastIndex = nextIdx;
                }
              } else {
                text.push(group.text);
              }
              return text;
            })()}
            <br />
          </button>,
        );
        results = [];
      }
      return this.captions;
    }
  }

  /* Printing Transcript */
  private printTranscript() {
    const ENV: string = 'https://www.att.com/media/gvp/';
    // nodes

    const logo: HTMLElement = document.createElement('div');
    logo.innerHTML = '<image src="' + ENV + 'view / images / logo.png"/>';
    const line1: HTMLElement = document.createElement('hr');
    line1.className = "TranscriptComponent__printLine1 color-gray-300";

    const description: HTMLElement = document.createElement('div');
    description.className = "TranscriptComponent__printdescription";

    if (this.props.data.thumbIcon) {
      description.innerHTML = '<div class=' + "TranscriptComponent__printdescription1" + '><img src="' + ENV + 'view / images / thumbnail_background.png" class=' + "TranscriptComponent__printbackgrimg" + '></img><img src="' + this.props.data.thumbIcon || '' + '" class=' + "TranscriptComponent__printthumbIcon" + '></img></div>';
    }
    description.innerHTML += '<div class=' + "TranscriptComponent__printvidouterdiv" + '><div class=' + "TranscriptComponent__printviddis color-gray-800" + '>VIDEO TRANSCRIPT</div><div class=' + "TranscriptComponent__printvidtitle color-gray-800" + '>' + (this.props.data.printTitle || '') + '</div><div class = "color-gray-600" style="font - size: 12pt; ">Total time: ' + (this.props.data.duration || '') + ' &#183; ' + (this.props.data.date || '') + '</div></div>';

    const line2: HTMLElement = document.createElement('hr');
    line2.className = "TranscriptComponent__printLine2 color-gray-300";

    const body: HTMLElement = document.createElement('div');
    body.className = "TranscriptComponent__printbody color-gray-800";
    body.innerHTML = '<div class=' + "TranscriptComponent__printbodymarginbottom" + '>To find this video online, enter the title in the site search box at att.com and select Videos & Tutorials from the results filters on the left.</br></br><b>Transcript Start</b></br></br></div>';

    const groups: Caption[] = Utils.groupCaptions(this.props.data.captionData!.captions);
    const groupLength: number = groups.length;
    let i = 0;
    for (i = 0; i < groupLength; i++) {
      body.innerHTML += '<div class = "color-gray-600" style="display: inline; ">' + Utils.secondsToTimecode(groups[i].begin) + ':</div><span>' + groups[i].text + '</span><br>';
    }

    body.innerHTML += '<div class=' + "TranscriptComponent__printbodymargintop" + '><b>Transcript End</b></br></br>* Transcript is provided as a convenience to viewers and does not contain entire content of video. To see entire content, which may include important legal disclosures, please refer to original video. &#169;2012 AT&T Intellectual Property. All rights reserved. AT&#38;T, the AT&#38;T logo, and all other AT&#38;T marks contained herein are trademarks of AT&#38;T Intellectual Property and/or AT&#38;T affiliated companies. All other marks contained herein are the property of their respective owners.</br></br></div>';

    const printable: HTMLElement = document.createElement('div');
    printable.appendChild(logo);
    printable.appendChild(line1);
    printable.appendChild(description);
    printable.appendChild(line2);
    printable.appendChild(body);
    console.log('printalble html ', printable);
    this.print(printable);
  }

  // PRINT PLUGIN
  // Create a jquery plugin that prints the given element.
  private print(printable: HTMLElement) {
    // NOTE: We are trimming the jQuery collection down to the
    // first element in the collection.
    // if (this.size() > 1) {
    //  this.eq(0).print();
    //  return;
    // } else if (!this.size()) {
    //  return;
    // }
    // ASSERT: At this point, we know that the current jQuery
    // collection (as defined by THIS), contains only one
    // printable element.

    // Create a random name for the print frame.
    const strFrameName: string = ('printer-' + (new Date()).getTime());

    // Create an iFrame with the new name.
    const jFrame: HTMLElement = document.createElement('iframe');
    jFrame.setAttribute('name', strFrameName);

    // Hide the frame (sort of) and attach to the body.
    // if (printable) {
    //     jFrame.css('width', '500px').css('height', '600px').css('position',
    //             'absolute').appendTo(jQuery('body'));
    // } else {
    jFrame.style.width = '1px';
    jFrame.style.height = '1px';
    jFrame.style.position = 'absolute';
    jFrame.style.left = '-9999px';
    document?.querySelector('body')?.appendChild(jFrame);
    //            jFrame.css('width', '1px').css('height', '1px').css('position',
    //                    'absolute').css('left', '-9999px').appendTo(jQuery('body'));
    //    }

    // Get a FRAMES reference to the new frame.
    // @ts-ignore: TODO
    const objFrame = window.frames[strFrameName];

    // Get a reference to the DOM in the new frame.
    const objDoc = objFrame.document;

    // Grab all the style tags and copy to the new
    // document so that we capture look and feel of
    // the current document.

    // Create a temp document DIV to hold the style tags.
    // This is the only way I could find to get the style
    // tags into IE.
    const jStyleDiv: HTMLElement = document.createElement('style');
    // jQuery('<div>').append(jQuery('style').clone());
    const styless = document.querySelectorAll('style');
    let i = 0;
    for (i = 0; i < styless.length; i++) {
      jStyleDiv.innerHTML += styless[i].innerHTML;
    }

    // Write the HTML for the document. In this, we will
    // write out the HTML of the current element.
    objDoc.open();
    objDoc
      .write('<!DOCTYPE html PUBLIC \'-//W3C//DTD XHTML 1.0 Transitional//EN\' \'http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\'>');
    objDoc.write('<html>');
    objDoc.write('<body>');
    objDoc.write('<head>');
    objDoc.write('<title>');
    objDoc.write(document.title);
    objDoc.write('</title>');
    objDoc.write(jStyleDiv.outerHTML);
    objDoc.write('</head>');
    objDoc.write(printable.innerHTML);
    objDoc.write('</body>');
    objDoc.write('</html>');
    objDoc.close();
    // Print the document.
    //  if (printable) {
    objFrame.focus();
    objFrame.print();
    // }

    // Have the frame remove itself in about a minute so that
    // we don't build up too many of these frames.
    setTimeout(() => {
      jFrame.remove();
    }, (60 * 1000));
  }
}

export default TranscriptComponent;
